import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=e56a55d0&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=e56a55d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a55d0",
  null
  
)

export default component.exports